<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { quinary } = $AppState.theme.colors.illustration;
</script>

<svg
  width="310"
  height="79"
  viewBox="0 0 310 79"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_4416:122361)">
    <path
      opacity="0.1"
      d="M168 52C166.035 46.6968 167.304 47.9657 162 46.0011C167.304 44.0365 166.035 45.3054 168 40C169.965 45.3032 168.696 44.0343 174 45.9989C168.696 47.9635 169.965 46.6946 168 52Z"
      fill={quinary}
    />
    <path
      opacity="0.6"
      d="M225 21C223.69 17.4645 224.536 18.3105 221 17.0007C224.536 15.691 223.69 16.5369 225 13C226.31 16.5355 225.464 15.6895 229 16.9993C225.464 18.309 226.31 17.4631 225 21Z"
      fill={quinary}
    />
    <path
      opacity="0.6"
      d="M69 40C67.035 34.6968 68.3042 35.9657 63 34.0011C68.3042 32.0365 67.035 33.3054 69 28C70.965 33.3032 69.6958 32.0343 75 33.9989C69.6958 35.9635 70.965 34.6946 69 40Z"
      fill={quinary}
    />
    <path
      opacity="0.3"
      d="M189 29C185.398 19.2775 187.724 21.6038 178 18.002C187.724 14.4002 185.398 16.7265 189 7C192.602 16.7225 190.276 14.3962 200 17.998C190.276 21.5998 192.602 19.2735 189 29Z"
      fill={quinary}
    />
    <path
      opacity="0.3"
      d="M296 68C294.69 64.4645 295.536 65.3105 292 64.0007C295.536 62.691 294.69 63.5369 296 60C297.31 63.5355 296.464 62.6895 300 63.9993C296.464 65.309 297.31 64.4631 296 68Z"
      fill={quinary}
    />
    <path
      opacity="0.3"
      d="M53.5 9C51.3713 3.25488 52.7462 4.62953 47 2.50118C52.7462 0.372835 51.3713 1.74749 53.5 -4C55.6287 1.74512 54.2538 0.370465 60 2.49881C54.2538 4.62716 55.6287 3.25251 53.5 9Z"
      fill={quinary}
    />
    <path
      opacity="0.6"
      d="M115.5 28C112.061 18.7194 114.282 20.94 105 17.5019C114.282 14.0638 112.061 16.2844 115.5 7C118.939 16.2806 116.718 14.06 126 17.4981C116.718 20.9362 118.939 18.7156 115.5 28Z"
      fill={quinary}
    />
    <path
      opacity="0.1"
      d="M8 30C5.38001 22.9291 7.07221 24.621 0 22.0015C7.07221 19.382 5.38001 21.0738 8 14C10.62 21.0709 8.92779 19.379 16 21.9985C8.92779 24.618 10.62 22.9262 8 30Z"
      fill={quinary}
    />
    <path
      opacity="0.3"
      d="M20 33C19.0175 30.3484 19.6521 30.9829 17 30.0005C19.6521 29.0182 19.0175 29.6527 20 27C20.9825 29.6516 20.3479 29.0171 23 29.9995C20.3479 30.9818 20.9825 30.3473 20 33Z"
      fill={quinary}
    />
    <path
      opacity="0.3"
      d="M147 8C146.018 5.3484 146.652 5.98286 144 5.00055C146.652 4.01823 146.018 4.65269 147 2C147.982 4.6516 147.348 4.01714 150 4.99945C147.348 5.98177 147.982 5.34731 147 8Z"
      fill={quinary}
    />
    <path
      opacity="0.3"
      d="M239 41C237.69 37.4645 238.536 38.3105 235 37.0007C238.536 35.691 237.69 36.5369 239 33C240.31 36.5355 239.464 35.6895 243 36.9993C239.464 38.309 240.31 37.4631 239 41Z"
      fill={quinary}
    />
  </g>
  <defs>
    <clipPath id="clip0_4416:122361">
      <rect width="310" height="79" fill="white" />
    </clipPath>
  </defs>
</svg>
